var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import 'whatwg-fetch';
/**
 * Laybuy BP helper
 *
 * Author: Leo Chen <leo.cxy88@gmail.com>
 * Date: 2020-07-10
 */
import debounce from 'lodash/debounce';
import add from 'lodash/add';
import subtract from 'lodash/subtract';
import divide from 'lodash/divide';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import has from 'lodash/has';
import merge from 'lodash/merge';
var location = window.location;
var LoggerLevel;
(function (LoggerLevel) {
    LoggerLevel["Debug"] = "log";
    LoggerLevel["Warn"] = "warn";
    LoggerLevel["Error"] = "error";
})(LoggerLevel || (LoggerLevel = {}));
var PageType;
(function (PageType) {
    PageType["Product"] = "product";
    PageType["Cart"] = "cart";
    PageType["Collection"] = "collection";
})(PageType || (PageType = {}));
var InjectType;
(function (InjectType) {
    InjectType[InjectType["Inside"] = 0] = "Inside";
    InjectType[InjectType["Before"] = 1] = "Before";
    InjectType[InjectType["After"] = 2] = "After";
})(InjectType || (InjectType = {}));
var Helper = /** @class */ (function () {
    function Helper() {
        var _this = this;
        this.popup_dom = document.createElement('div');
        this.list_doms = [];
        this.support_currency = false;
        // Export debounce fn
        this.debounce = debounce;
        this.run = function (configs) {
            console.log('%cHello, here is LaybuyHelper!\nIf you need any help, please contact support@laybuy.com.\nHave a nice day!', 'color: #786dff; background: #eee; font-size:18px;');
            _this.configs = configs;
            // Overwrite configs
            if (has(configs, 'overwrite.configs')) {
                var overwrite = __assign({}, configs.overwrite.configs);
                if (has(overwrite, 'shop'))
                    _this.configs.shop = merge(_this.configs.shop, overwrite.shop);
                if (has(overwrite, 'currencies'))
                    _this.configs.currencies = merge(_this.configs.currencies, overwrite.currencies);
            }
            _this.support_currency = _this.check_currency();
            if (!_this.support_currency)
                return;
            if (/\/products\//i.test(location.pathname) || /api\/preview\/\d+\/1/i.test(location.pathname)) {
                _this.current_type = PageType.Product;
                return _this.product();
            }
            else if (/\/cart/i.test(location.pathname) || /api\/preview\/\d+\/2/i.test(location.pathname)) {
                _this.current_type = PageType.Cart;
                return _this.cart();
            }
            else if (/\/collections\//i.test(location.pathname) || /api\/preview\/\d+\/4/i.test(location.pathname)) {
                _this.current_type = PageType.Collection;
                return _this.collection();
            }
        };
        this.logger = function (msg, lv) {
            if (lv === void 0) { lv = LoggerLevel.Debug; }
            console[lv]("laybuy helper: " + msg);
        };
        this.init_popup_iframe = function () {
            var popup_outer = document.createElement('div'), popup_inner = document.createElement('div'), popup_iframe = document.createElement('iframe'), popup_btn = document.createElement('a'), close_fn = function (ev) {
                ev.preventDefault();
                _this.popup_dom.style.display = 'none';
            };
            // iframe
            popup_iframe.setAttribute('src', 'https://popup.laybuy.com/');
            popup_inner.appendChild(popup_iframe);
            // close btn
            popup_btn.setAttribute('href', '#');
            popup_btn.style.position = 'absolute';
            popup_btn.style.right = '8px';
            popup_btn.style.top = '8px';
            popup_btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32" version="1.1" width="24px" height="24px"><g id="surface1"><path style=" " d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 12.21875 10.78125 L 10.78125 12.21875 L 14.5625 16 L 10.78125 19.78125 L 12.21875 21.21875 L 16 17.4375 L 19.78125 21.21875 L 21.21875 19.78125 L 17.4375 16 L 21.21875 12.21875 L 19.78125 10.78125 L 16 14.5625 Z "/></g></svg>';
            popup_btn.addEventListener('click', close_fn);
            popup_inner.appendChild(popup_btn);
            // inner
            popup_inner.setAttribute('id', 'laybuy-popup-inner');
            popup_outer.appendChild(popup_inner);
            // outer
            popup_outer.setAttribute('id', 'laybuy-popup-outer');
            _this.popup_dom.appendChild(popup_outer);
            // close popup
            _this.popup_dom.addEventListener('click', close_fn);
            // inject to body
            _this.popup_dom.setAttribute('id', 'laybuy-popup-wrapper');
            document.querySelector('body').appendChild(_this.popup_dom);
        };
        this.bind_popup_event = function (paragraph) {
            var trigger = paragraph.querySelector('a.laybuy-link');
            if (trigger)
                trigger.addEventListener('click', function (e) {
                    e.preventDefault();
                    _this.popup_dom.style.display = 'block';
                });
        };
        // Reload Laybuy PB
        this.reload = function (hide) {
            if (hide === void 0) { hide = false; }
            _this.list_doms.forEach(function (dom) {
                hide ? dom.classList.add('hide') : dom.classList.remove('hide');
            });
        };
        this.check_currency = function (currency) {
            currency = currency || _this.configs.shop.currency;
            _this.current_currency = _this.configs.currencies.find(function (o) { return o.iso_code.toUpperCase().trim() == currency.toLocaleUpperCase().trim(); });
            if (!_this.current_currency) {
                _this.logger(currency + " is not support with laybuy!", LoggerLevel.Error);
                _this.reload(true);
            }
            return true;
        };
        this.currencty_observe = function () {
            // this.configs.shop.currency = currency;
            // this.check_currency(currency)
        };
        this.get_price_from_html = function (price) {
            price = price.replace(/[^0-9.]/g, "");
            return price.indexOf('.') !== -1 ? price.replace('.', '') : price;
        };
        this.query_observe_element = function (selector) {
            var dom;
            try {
                dom = document.querySelector(selector);
            }
            catch (e) {
                _this.logger(e, LoggerLevel.Error);
                _this.logger('Unable to detect the observe element', LoggerLevel.Error);
                throw "Unable to detect the observe element by selector: " + selector;
            }
            if (!dom)
                throw "Unable to detect the observe element by selector: " + selector;
            return dom;
        };
        this.price_mutation = function (price, price_type) {
            if (price_type === void 0) { price_type = 'product'; }
            if (!isUndefined(_this.configs.overwrite)) {
                switch (price_type) {
                    case 'product':
                        if (isFunction(_this.configs.overwrite.product_mutation))
                            return _this.configs.overwrite.product_mutation.bind(_this, price)();
                        break;
                    case 'cart':
                        if (isFunction(_this.configs.overwrite.cart_mutation))
                            return _this.configs.overwrite.cart_mutation.bind(_this, price)();
                        break;
                }
            }
            var instalment;
            if (price >= _this.current_currency.max) {
                instalment = subtract(price, _this.current_currency.max);
                instalment = divide(add(instalment, divide(_this.current_currency.max, 6)), 100).toFixed(2);
                var remain_instalment_1 = divide(divide(_this.current_currency.max, 6), 100).toFixed(2);
                _this.list_doms.forEach(function (dom) {
                    dom.classList.remove('hide');
                    dom.classList.add('over');
                    dom.querySelector('.first-instalment-price > span').innerHTML = "" + _this.current_currency.symbol + instalment;
                    dom.querySelector('.max-instalment-price > span').innerHTML = "" + _this.current_currency.symbol + remain_instalment_1;
                });
            }
            else if (price <= 6) {
                instalment = 0;
                _this.list_doms.forEach(function (dom) {
                    dom.classList.remove('over');
                    dom.classList.add('hide');
                    dom.querySelector('.first-instalment-price > span').innerHTML = "" + _this.current_currency.symbol + instalment;
                });
            }
            else {
                instalment = divide(price, 600).toFixed(2);
                _this.list_doms.forEach(function (dom) {
                    dom.classList.remove('over', 'hide');
                    dom.querySelector('.first-instalment-price > span').innerHTML = "" + _this.current_currency.symbol + instalment;
                });
            }
        };
        this.construct_paragraph = function (variant, text_prefix) {
            if (text_prefix === void 0) { text_prefix = 'product'; }
            var texts, instalment, global_texts = _this.configs.shop.texts.global;
            if (variant.price > _this.current_currency.max) {
                texts = _this.configs.shop.texts.over;
                instalment = subtract(variant.price, _this.current_currency.max);
                instalment = divide(add(instalment, divide(_this.current_currency.max, 6)), 100).toFixed(2);
                _this.virtual_dom.classList.add('over');
            }
            else if (variant.price <= 6) {
                texts = _this.configs.shop.texts.standard;
                instalment = 0;
                _this.virtual_dom.classList.add('hide');
            }
            else {
                texts = _this.configs.shop.texts.standard;
                instalment = divide(variant.price, 600).toFixed(2);
            }
            _this.virtual_dom.insertAdjacentHTML('beforeend', "<span class=\"laybuy-text1\">" + texts[text_prefix + '_line_1'] + "</span>");
            _this.virtual_dom.insertAdjacentHTML('beforeend', "\n            <span class=\"laybuy-instalments first-instalment-price\">\n                <span class=\"money laybuy-money\" data-money-convertible>" + _this.current_currency.symbol + instalment + "</span>\n            </span>\n        ");
            // only show if price > max
            _this.virtual_dom.insertAdjacentHTML('beforeend', "\n            <span class=\"laybuy-text2\">" + global_texts[text_prefix + '_line_3'] + "</span>\n            <span class=\"laybuy-instalments max-instalment-price\">\n                <span class=\"money laybuy-money\" data-money-convertible>" + _this.current_currency.symbol + divide(_this.current_currency.max, 600).toFixed(2) + "</span>\n            </span>\n        ");
            _this.virtual_dom.insertAdjacentHTML('beforeend', "<span class=\"laybuy-text3\">" + global_texts[text_prefix + '_line_2'] + "</span>");
            switch (text_prefix) {
                case 'cart':
                case 'product':
                    _this.virtual_dom.insertAdjacentHTML('beforeend', "<span class=\"laybuy-logo-and-text\">\n                    " + _this.configs.shop.logo_html + "\n                    <a class=\"laybuy-link\" href=\"https://www.laybuy.com/how-it-works\" target=\"_blank\"><span class=\"laybuy-link-inner\">what's this?</span></a>\n                </span>");
                    break;
                case 'collection':
                    _this.virtual_dom.insertAdjacentHTML('beforeend', "<span class=\"laybuy-logo-and-text\">" + _this.configs.shop.logo_html + "</span>");
                    break;
            }
            // overwrite styling
            for (var x in _this.configs.style) {
                _this.virtual_dom.style[x] = _this.configs.style[x];
                // Logo Img
                var logo = _this.virtual_dom.querySelector('img');
                if (logo)
                    logo.className = _this.configs.logo_class[text_prefix] || 'small';
            }
        };
        this.product_paragraph = function (config) {
            var variant;
            _this.virtual_dom = document.createElement('p');
            _this.virtual_dom.classList.add('laybuy-paragraph');
            _this.virtual_dom.setAttribute('data-product-id', config.productData.id);
            variant = config.productData.variants.find(function (v) { return v.id == config.variantID; });
            if (!variant) {
                _this.logger('The product is not avaiable!', LoggerLevel.Warn);
                return;
            }
            _this.construct_paragraph(variant);
        };
        this.cart_paragraph = function (cart) {
            _this.virtual_dom = document.createElement('p');
            _this.virtual_dom.classList.add('laybuy-paragraph');
            _this.construct_paragraph({ price: cart.total_price }, 'cart');
        };
        this.collection_paragraph = function (price, index) {
            var variant = { price: parseInt(_this.get_price_from_html(price)) };
            _this.virtual_dom = document.createElement('p');
            _this.virtual_dom.classList.add('laybuy-paragraph');
            _this.virtual_dom.dataset.index = index + '';
            _this.construct_paragraph(variant, 'collection');
        };
        this.construct_observe = function (config, observe_type, check_overwrite) {
            if (observe_type === void 0) { observe_type = 'product'; }
            if (check_overwrite === void 0) { check_overwrite = true; }
            if (!isUndefined(_this.configs.overwrite)) {
                switch (observe_type) {
                    case 'product':
                        if (isFunction(_this.configs.overwrite.product_observe) && check_overwrite)
                            return _this.configs.overwrite.product_observe.bind(_this, config)();
                        break;
                    case 'cart':
                        if (isFunction(_this.configs.overwrite.cart_observe) && check_overwrite)
                            return _this.configs.overwrite.cart_observe.bind(_this, config)();
                        break;
                    case 'collection':
                        if (isFunction(_this.configs.overwrite.collection_observe) && check_overwrite)
                            return _this.configs.overwrite.collection_observe.bind(_this, config)();
                        break;
                }
            }
            switch (observe_type) {
                case 'product':
                    _this.product_observe(config);
                    break;
                case 'cart':
                    _this.cart_observe(config);
                    break;
                case 'collection':
                    _this.collection_observe(config);
                    break;
            }
        };
        this.product_observe = function (config) {
            // Mutation - IE 11+
            if (!isUndefined(config.ajaxSelector)) {
                var observe = void 0, price_dom_1;
                price_dom_1 = _this.query_observe_element(config.ajaxSelector);
                observe = new MutationObserver(debounce(function () { return _this.price_mutation(parseInt(_this.get_price_from_html(price_dom_1.innerText))); }, 250));
                return observe.observe(price_dom_1, {
                    childList: !0,
                    attributes: !1,
                    characterData: !0,
                    subtree: !0,
                    attributeOldValue: !1,
                    characterDataOldValue: !1
                });
            }
            // Form Change
            var selected_variant_id, variant;
            document.querySelector('body form[action^="/cart/add"]').addEventListener('change', function () {
                setTimeout(function () {
                    selected_variant_id = parseInt(document.querySelector('body form[action^="/cart/add"] input[name=id]:checked, select[name=id], input[name=id], hidden[name=id]').value, 10);
                    if (isUndefined(selected_variant_id)) {
                        _this.reload(true);
                        return _this.logger('Form Changed, bun unable to detect selected variant id!', LoggerLevel.Warn);
                    }
                    variant = config.productData.variants.find(function (v) { return v.id === selected_variant_id; });
                    if (isUndefined(variant)) {
                        _this.reload(true);
                        _this.logger('Unable to find the match variant!', LoggerLevel.Warn);
                    }
                    else {
                        _this.reload(false);
                        _this.price_mutation(variant.price);
                    }
                }, 100);
            });
        };
        this.cart_observe = function (config) {
            // Mutation
            if (isUndefined(config.ajaxSelector))
                return;
            var observe, dom;
            dom = _this.query_observe_element(config.ajaxSelector);
            observe = new MutationObserver(debounce(function () {
                fetch('/cart.json', {
                    method: 'get',
                    mode: "same-origin",
                    headers: { 'Content-Type': 'application/json' }
                }).then(function (res) { return res.json(); })
                    .then(function (res) {
                    _this.price_mutation(res.total_price, 'cart');
                });
            }, 500));
            observe.observe(dom, {
                childList: !0,
                attributes: !1,
                characterData: !0,
                subtree: !0,
                attributeOldValue: !1,
                characterDataOldValue: !1
            });
        };
        this.collection_observe = function (config) {
            if (isUndefined(config.ajaxSelector))
                return;
            var observe, dom, clone_dom;
            dom = _this.query_observe_element(config.ajaxSelector);
            observe = new MutationObserver(debounce(function () {
                // Remove all the list
                _this.list_doms.forEach(function (target) { return target.parentNode.removeChild(target); });
                _this.list_doms = [];
                document.querySelectorAll(config.selector).forEach(function (target, index) {
                    _this.collection_paragraph(target.innerText, index);
                    clone_dom = _this.virtual_dom.cloneNode(true);
                    // inject element
                    _this.inject_paragraph(target, clone_dom, config.inject, config.inject_pos);
                });
            }, 250));
            observe.observe(dom, {
                childList: !0,
                attributes: !1,
                characterData: !1,
                subtree: !0,
                attributeOldValue: !1,
                characterDataOldValue: !1
            });
        };
        this.inject_paragraph = function (target, new_node, inject, pos) {
            if (pos === void 0) { pos = 0; }
            while (pos > 0) {
                target = target.parentNode;
                pos -= 1;
            }
            switch (inject) {
                case InjectType.After:
                    target.parentNode.insertBefore(new_node, target.nextSibling);
                    break;
                case InjectType.Before:
                    target.parentNode.insertBefore(new_node, target);
                    break;
                case InjectType.Inside:
                default:
                    target.appendChild(new_node);
            }
            // Add to list
            _this.list_doms.push(new_node);
        };
        this.product = function () {
            if (!_this.configs.product.enable)
                return;
            if (!isUndefined(_this.configs.overwrite) && isFunction(_this.configs.overwrite.product_init))
                return _this.configs.overwrite.product_init.bind(_this)();
            var config = _this.configs.product, target_list, clone_dom;
            if (config.productData == null) {
                return _this.logger('Invalid product data!', LoggerLevel.Error);
            }
            try {
                target_list = document.querySelectorAll(config.selector);
                if (target_list.length == 0) {
                    return _this.logger('Unable to find inject target!', LoggerLevel.Error);
                }
            }
            catch (e) {
                _this.logger(e, LoggerLevel.Error);
                return _this.logger('Unable to find inject target!', LoggerLevel.Error);
            }
            // construct paragraph
            _this.product_paragraph(config);
            // inject popup
            _this.init_popup_iframe();
            // inject paragraph
            target_list.forEach(function (target) {
                // generate a element
                clone_dom = _this.virtual_dom.cloneNode(true);
                // bind event
                _this.bind_popup_event(clone_dom);
                // Inject element
                _this.inject_paragraph(target, clone_dom, config.inject, config.inject_pos);
                // Added To List
                _this.list_doms.push(clone_dom);
            });
            // observer
            _this.construct_observe(config, 'product');
            // currency observe @todo
        };
        this.cart = function () {
            if (!_this.configs.cart.enable)
                return;
            if (!isUndefined(_this.configs.overwrite) && isFunction(_this.configs.overwrite.cart_init))
                return _this.configs.overwrite.cart_init.bind(_this)();
            var config = _this.configs.cart, target, clone_dom;
            try {
                target = document.querySelector(config.selector);
                if (!target)
                    return _this.logger('Unable to find inject target!', LoggerLevel.Error);
            }
            catch (e) {
                _this.logger(e, LoggerLevel.Error);
                return _this.logger('Unable to find inject target!', LoggerLevel.Error);
            }
            // inject popup
            _this.init_popup_iframe();
            // construct paragraph
            fetch('/cart.json', { method: 'get', mode: "same-origin", headers: { 'Content-Type': 'application/json' } })
                .then(function (res) { return res.json(); })
                .then(function (res) {
                _this.cart_paragraph(res);
                // clone the node
                clone_dom = _this.virtual_dom.cloneNode(true);
                // bind event
                _this.bind_popup_event(clone_dom);
                // inject paragraph
                _this.inject_paragraph(target, clone_dom, config.inject, config.inject_pos);
            });
            // observe mutation
            _this.construct_observe(config, 'cart');
            // currency observe @todo
        };
        this.collection = function () {
            if (!_this.configs.collection.enable)
                return;
            if (_this.configs.overwrite && isFunction(_this.configs.overwrite.collection_init))
                return _this.configs.overwrite.collection_init.bind(_this)();
            var config = _this.configs.collection, target_list, clone_dom;
            if (!config.selector) {
                _this.logger('Invalid css selector for collection page!', LoggerLevel.Error);
                return;
            }
            try {
                target_list = document.querySelectorAll(config.selector);
                if (target_list.length == 0) {
                    return _this.logger('Unable to find any target!', LoggerLevel.Error);
                }
            }
            catch (e) {
                _this.logger(e, LoggerLevel.Error);
                return _this.logger('Unable to find any target!', LoggerLevel.Error);
            }
            // inject paragraph
            target_list.forEach(function (target, index) {
                _this.collection_paragraph(target.innerText || target.innerHTML, index);
                clone_dom = _this.virtual_dom.cloneNode(true);
                // inject element
                _this.inject_paragraph(target, clone_dom, config.inject, config.inject_pos);
            });
            // observer
            _this.construct_observe(config, 'collection');
            // currency observer @todo
        };
    }
    return Helper;
}());
export default new Helper();
